// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__Wy7Vz","list":"Tabs_list__7FhBp","clearFilter":"Tabs_clearFilter__B6QYA","sortContainer":"Tabs_sortContainer__Funpx","panel":"Tabs_panel__Ag8zr"};